module.exports = __webpack_public_path__ + "img/home-bg.c131b9ba.png";